// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.atmo-hash-jump-point[data-v-3fdc5686] {\n    scroll-margin-top: 190px;\n}\n", ""]);
// Exports
module.exports = exports;
